import type { Post } from '@/@types/post'
import { showConfirm } from '@/components/Modal/utils'
import { useCallback } from 'react'
import toast from 'react-hot-toast'
import { usePostActionsContext } from '../PostActionsContext'
import { ActionMenu } from '../config'
import { showPostFormModal } from '../utils'
import styles from './useMoreActionsMenuSelectHandler.module.css'
import {
	usePostCollectToggle,
	usePostDelete,
	usePostPinToggle,
	usePostSponsorVisibilityToggle,
} from './usePostActionHandlers'

export default function useMoreActionsMenuSelectHandler(data: Post) {
	const { refresh: refreshList } = usePostActionsContext()

	const { togglePin } = usePostPinToggle(data.id)
	const { deletePost } = usePostDelete(data.id)
	const { toggleCollect } = usePostCollectToggle(data.id)
	const { togglePostVisibility } = usePostSponsorVisibilityToggle(data.id)

	return useCallback(
		async (menuId: string) => {
			if (!data) {
				return
			}

			switch (menuId as ActionMenu) {
				case ActionMenu.PIN:
				case ActionMenu.UNPIN:
					await togglePin()
					await refreshList?.()
					break
				case ActionMenu.COLLECT:
					await toggleCollect()
					toast.success('已收藏')
					await refreshList?.()
					break
				case ActionMenu.UNCOLLECT:
					await toggleCollect()
					toast.success('已取消收藏')
					await refreshList?.()
					break
				case ActionMenu.TO_SELF_ONLY:
				case ActionMenu.TO_PUBLIC:
					await togglePostVisibility()
					break
				case ActionMenu.EDIT_POST:
					showPostFormModal(data.id)
					break
				case ActionMenu.DELETE:
					await showConfirm(
						'确定删除吗？',
						<div className={styles.confirmText}>删除后无法恢复</div>
					)
					await deletePost()
					break
			}
		},
		[data, deletePost, refreshList, toggleCollect, togglePin, togglePostVisibility]
	)
}
